import { Box, styled, ToggleButton, Typography } from '@mui/material';

import { ExtendedToggleButtonGroup } from 'infrastructure/components/ButtonsGroup/components/ExtendedToggleButtonGroup';

export const InfoCardVariantStyledToggleButtonGroup = styled(ExtendedToggleButtonGroup)(
  ({ theme, shouldstayinonerow }) => ({
    width: '100%',
    height: '150px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      flexWrap: 'nowrap',
      height: 'auto',
      overflowY: 'hidden',
      overflowX: 'auto',
      scrollbarWidth: 'thin',
      '&::-webkit-scrollbar': {
        height: '6px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
        borderRadius: '3px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '3px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      flexWrap: shouldstayinonerow ? 'nowrap' : 'wrap',
      overflowX: shouldstayinonerow ? 'auto' : 'visible',
      overflowY: 'hidden',
      gap: theme.spacing(2),
    },
  }),
);

export const StyledButtonsGroupContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
}));

export const StyledButtonSubtitle = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    paddingTop: '0px',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
}));

export const StyledButtonLabel = styled(Typography)(({ theme }) => ({
  padding: '8px 12px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '0px',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
}));

export const StyledButtonTitle = styled(Typography)(({ theme }) => ({
  padding: '8px 12px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '0px',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
}));

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  width: '100%',
  maxWidth: '200px',
  minWidth: '100px',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '5px 2px 5px 2px',
  background: '#FFF',
  borderRadius: '8px',
  '&.Mui-selected': {
    display: 'block',
    color: `${theme.palette.secondary.contrastText} !important`,
    '& .MuiTypography-body2': {
      color: `${theme.palette.secondary.contrastText} !important`,
    },
    '& .MuiTypography-h6': {
      color: `${theme.palette.secondary.contrastText} !important`,
    },
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    height: 'auto',
    minWidth: '120px',
    flexShrink: 0,
  },
}));
